<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3 text-right">
              <button
                type="button"
                class="btn bg-white search-box border-secondary rounded-5 mr-3 mb-lg-0 mb-3"
                style="height: 42px"
              >
                <a class="text-secondary waves-effect waves-dark p-0" href="javascript:void(0)">
                  <i class="fas fa-search font-16"></i>
                </a>
                <form class="app-search position-absolute" v-on:submit.prevent>
                  <input
                    type="text"
                    class="form-control"
                    v-model="filterObj.search"
                    v-bind:placeholder="$lang.messages.search_enter"
                    v-on:keyup.enter="getList(1)"
                  />
                  <a class="srh-btn">
                    <i class="ti-close"></i>
                  </a>
                </form>
              </button>
              <div
                class="text-right custom-select-dd d-inline-block mr-lg-3 mr-md-1 mb-lg-0 mb-3 w-xs-100"
                style="width: 160px;"
              >
                <select v-model="filterObj.store_id" @change="getList(1)" class="form-control">
                  <option value>{{$lang.messages.all_stores}}</option>
                  <option
                    v-for="store in all_stores"
                    :key="store.id"
                    :value="store.id"
                  >{{store.name}}</option>
                </select>
              </div>

              <a
                href="javascript:void(0)"
                @click="clearAddModal()"
                class="btn btn-primary px-4"
                data-toggle="modal"
                data-target="#AddReview"
              >+ {{$lang.messages.add_review}}</a>
            </div>

            <div class="card rounded-5">
              <div class="bg-white mt-3"></div>
              <div class="card-body pt-0">
                <table class="table table-striped table-style-1 table-responsive">
                  <thead>
                    <tr>
                      <th scope="col">Sr.no</th>
                      <th
                        scope="col"
                        class="sorting"
                        @click="Sorting($event, 'name')"
                      >{{$lang.messages.name}}</th>
                      <th
                        scope="col"
                        class="sorting"
                        @click="Sorting($event, 'store_name')"
                      >{{$lang.messages.store}}</th>
                      <th scope="col" class="text-center">{{$lang.messages.action}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(menu,i) in list" :key="menu.id">
                      <td>{{i +1}}</td>
                      <td>{{menu.parameter}}</td>
                      <td>{{menu.store_name}}</td>
                      <td class="text-center">
                        <a
                          href="javascript:void(0)"
                          @click="gotoEdit(menu.id)"
                          class="text-primary mr-2 font-18"
                        >
                          <i class="mdi mdi-pencil font-20"></i>
                        </a>
                        &nbsp;&nbsp;
                        <a
                          href="javascript:void(0)"
                          data-toggle="modal"
                          data-target="#delete-review-modal"
                          @click="setObj(menu.id)"
                          class="text-grey font-18"
                        >
                          <i class="far fa-trash-alt font-20 text-danger"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <ErrorComponent @retry="retry()" ref="errorComonent" />
              </div>
            </div>

            <div class="page-bottom-pagination text-right">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange"
                ref="reviewPagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="AddReview"
      tabindex="-1"
      role="dialog"
      aria-labelledby="AddReview"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content px-lg-4 py-lg-4">
          <div class="modal-header border-0">
            <h5
              class="modal-title font-22"
            >{{review.id ? $lang.messages.update_review : $lang.messages.add_review}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form @submit.prevent="validateBeforeSubmit">
            <div class="modal-body form-style">
              <div class="row mb-4">
                <div class="col-lg-12 mb-4">
                  <label for>{{$lang.messages.name}}</label>
                  <span style="color:#ff0000">*</span>
                  <input
                    name="name"
                    v-model="review.parameter"
                    v-validate="'required'"
                    class="form-control"
                    :class="{'input': true, 'is-danger': errors.has('name') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.name"
                  />
                  <i v-show="errors.has('name')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('name')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_name}}</span>
                </div>

                <div class="col-lg-12 mb-4">
                  <label for>{{$lang.messages.store}}</label>
                  <span style="color:#ff0000">*</span>
                  <select
                    v-model="review.store_id"
                    class="form-control"
                    v-validate="'required'"
                    :class="{'input': true, 'is-danger': errors.has('store_id') }"
                    name="store_id"
                  >
                    <option value>{{$lang.messages.select_store}}</option>
                    <option
                      v-for="store in all_stores"
                      :key="store.id"
                      :value="store.id"
                    >{{store.name}}</option>
                  </select>
                  <i v-show="errors.has('store_id')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('store_id')"
                    class="help is-danger"
                  >{{$lang.messages.please_select_store}}</span>
                </div>
              </div>
            </div>

            <div class="modal-footer border-0 justify-content-center">
              <button
                type="submit"
                class="btn btn-primary mr-3"
                id="save-btn"
              >{{$lang.messages.save_btn_text}}</button>

              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-primary"
                id="cancel-btn"
              >{{$lang.messages.cancel_btn_text}}</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <Alert
      @rightButtonEvent="deleteReview($event)"
      v-bind:title="$lang.messages.delete_review"
      ref="deleteReviewAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-review-modal"
    />
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
export default {
  name: "Review",
  components: {
    Pagination,
    ErrorComponent,
    Alert
  },
  data() {
    return {
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      country_code: "",
      review: {
        id: "",
        parameter: "",
        store_id: ""
      },
      list: [],
      all_stores: [],
      currentSorting: "",
      filterObj: {
        sort_by: "",
        order_by: "ASC",
        store_id: "",
        search: "",
        status: ""
      }
    };
  },
  methods: {
    inProgress() {
      alert("In progress");
    },
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.reviewPagination.itemsPerPage;
      this.getList(1);
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.add();
          return;
        }
      });
    },
    getAllStoreList() {
      this.$api
        .getAPI({
          _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}`,
          _hide_loader: true
        })
        .then(res => {
          this.all_stores = res.list;
        });
    },
    clearAddModal() {
      this.review.id = "";
      this.review.parameter = "";
      this.review.store_id = "";
      this.$validator.reset();
      this.errors.clear();
    },
    setObj(id) {
      this.review.id = id;
      this.$refs.deleteReviewAlert.message = this.$lang.messages.are_you_sure_you_want_to_delete_the_review;
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.add();
          return;
        }
      });
    },
    deleteReview(e) {
      if (this.review.id) {
        this.$api
          .deleteAPI({
            _action: "/review_parameter/delete/" + this.review.id
          })
          .then(res => {
            this.$refs.deleteReviewAlert.close();
            this.$notify({
              group: "foo",
              text: res.message,
              type: "success"
            });
            this.review.id = "";
            this.getList(1);
          })
          .catch(e => {
            this.$refs.deleteReviewAlert.close();
          });
      }
    },
    gotoEdit(id) {
      this.details(id);
      $("#AddReview").modal("show");
    },

    details(id) {
      this.review = {};
      this.$api
        .getAPI({
          _action: "/review_parameter/detail/" + id
        })
        .then(res => {
          this.review = res;
        });
    },
    retry() {
      this.getList(1);
    },
    getList(page, sortBy, orderBy) {
      this.list = [];

      this.currentPage = page;

      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }

      this.$api
        .getAPI({
          _action: "/review_parameter/lists/" + this.itemsPerPage + "/" + page,
          _body: this.filterObj
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.list = res.list;
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.reviewPagination.setTotalCount(res.count);
            } else {
              this.$refs.reviewPagination.setTotalCount(0);
            }
          }
          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(
              this.$lang.messages.no_reviews_found
            );
          } else {
            if (this.$refs.errorComonent.isShowMessage()) {
              this.$refs.errorComonent.setTitle();
            }
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },
    add() {
      this.$api
        .postAPI({
          _action: "/review_parameter/",
          _body: this.review,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          document.getElementById("cancel-btn").click();
          this.getList(1);
        })
        .catch(e => {
          console.log(e.message);
        });
    },
    sorting(e, sortBy) {
      var orderBy = "ASC";

      var className = "sorting_asc";
      var classes = e.target.className;
      if (classes.includes("sorting_asc")) {
        className = "sorting_desc";
      }

      $(".sorting_asc").removeClass("sorting_asc");
      $(".sorting_desc").removeClass("sorting_desc");

      if (className == "sorting_asc") {
        $(e.target)
          .addClass("sorting_asc")
          .removeClass("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        $(e.target)
          .addClass("sorting_desc")
          .removeClass("sorting_asc");
        orderBy = "DESC";
      }
      this.getList(1, sortBy, orderBy);
    }
  },
  mounted() {
    $(".search-box a, .search-box .app-search .srh-btn").on(
      "click",
      function() {
        $(".app-search").toggle(200);
        $(".app-search input").focus();
      }
    );
    this.getList(1);
    this.getAllStoreList();
  }
};
</script>
